import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import styled from 'styled-components';
import { Body } from '@lendi-ui/typography';
import { mb, px, py } from '@lendi-ui/spacing';
import Grid from '@lendi-ui/grid';
import { Button } from '@lendi-ui/button';

import { FUNNEL_CONTAINER_GRID_OPTIONS, FREQUENCY_OPTIONS } from '@funnels/constants';

import { CheckboxesField, RadioButtonsField, DollarInputField, DropdownField } from '../../Fields';
import { FullWidth } from '..';
import { FieldLabel } from '../../Fields/_common/FieldLabel';
import Stack from '../../Stack';

const FunnelWrapper = styled.div`
  max-width: 60rem;
  margin: 0 auto;
  position: relative;
`;

export function FunnelContainer(props: { children: React.ReactNode }) {
  return (
    <FunnelWrapper>
      <Grid gutter="nil">
        <Grid.Unit {...FUNNEL_CONTAINER_GRID_OPTIONS}>{props.children}</Grid.Unit>
      </Grid>
    </FunnelWrapper>
  );
}

export function Form(props: any) {
  return (
    <FinalForm initialValues={props.initialValues ? props.initialValues : {}} onSubmit={() => undefined}>
      {(formState) => {
        return (
          <form onSubmit={formState.handleSubmit}>
            <>
              {props.children(formState)}
              {props.hasSubmit && (
                <>
                  <br />
                  <Button variant="primary" size="sm" type="submit">
                    Continue
                  </Button>
                </>
              )}
            </>
          </form>
        );
      }}
    </FinalForm>
  );
}

export function Checkboxes(props: any) {
  const checkboxes = props.checkboxes ?? [
    { label: 'First option', value: 'o-1', isDisabled: false },
    { label: 'Second option', value: 'o-2', isDisabled: false },
    { label: 'Third option', value: 'o-3', isDisabled: false },
  ];

  const shouldDisableNonExclusive =
    props.isFirstExclusive && props.values && props.values.includes(checkboxes[0].value);

  if (shouldDisableNonExclusive) {
    checkboxes[1].isDisabled = true;
    checkboxes[2].isDisabled = true;
  }

  return (
    <CheckboxesField
      key={`checkoxes-${shouldDisableNonExclusive ? 'exclusive' : 'inclusive'}`}
      name="checkboxes"
      label="Question"
      checkboxes={checkboxes}
      values={props.values}
    />
  );
}

export function Radios(props: any) {
  return (
    <RadioButtonsField
      name="radios"
      label="Question"
      radios={[
        { label: 'First option', value: 'o-1' },
        { label: 'Second option', value: 'o-2' },
      ]}
      selectedValue={props.value}
      isBoxed={false}
    />
  );
}

export function BinaryRadioPlusAmountFrequency(props: any) {
  return (
    <Stack gutter="md" direction="column">
      <FullWidth>
        <RadioButtonsField
          label="Question"
          name="binary"
          direction="row"
          radios={[
            { label: 'Yes', value: 'YES' },
            { label: 'No', value: 'NO' },
          ]}
          selectedValue={props.values.binary}
          validationFailMessage={'Please complete the above to proceed.'}
        />
      </FullWidth>
      {props.values.binary === 'YES' && (
        <FullWidth>
          <AmountFrequency label="Sub question" />
        </FullWidth>
      )}
    </Stack>
  );
}

export function AmountFrequency(props: any) {
  return (
    <div>
      <FieldLabel label={props.label ?? 'Question'} />
      <FullWidth>
        <Grid gutter="sm">
          <Grid.Unit size={1 / 2}>
            <DollarInputField name="amount" isZeroValid isOptional isFullWidth />
          </Grid.Unit>
          <Grid.Unit size={1 / 2}>
            <DropdownField name="frequency" options={FREQUENCY_OPTIONS} isFullWidth />
          </Grid.Unit>
        </Grid>
      </FullWidth>
    </div>
  );
}

export const Paragraph = styled(Body)<{ align: 'left' | 'right' | 'center' }>`
  text-align: ${(props: any) => props.align ?? 'left'};
`;

export const InfoboxContainer = styled.div`
  ${mb('md')}
`;
